import script from "./RecordTile.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordTile.vue?vue&type=script&setup=true&lang=js"

import "./RecordTile.vue?vue&type=style&index=0&id=4dfcc4c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfcc4c6"]])

export default __exports__